import React from "react";
import { List } from "../modules/Transactions";

export function TransactionsPage(props) {
  return <List {...props} />;
}
